import React from "react";
import { Link } from "react-router-dom";

const PaymentCancel = () => (
  <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-6">
    <p className="font-serif text-5xl mb-4">Payment not completed.</p>
    <p className="text-espresso/60 mb-8">Your selection is still waiting for you.</p>
    <div className="flex gap-3">
      <Link to="/checkout" className="border border-espresso px-8 py-3.5 text-[0.72rem] tracking-[0.2em] uppercase hover:bg-espresso hover:text-cream transition-colors">Return to Checkout</Link>
      <Link to="/" className="px-8 py-3.5 text-[0.72rem] tracking-[0.2em] uppercase hover-underline">Continue Shopping</Link>
    </div>
  </div>
);

export default PaymentCancel;
